var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.63223 13.916L8.26831 19.0346C8.78898 19.0346 9.01448 18.811 9.2849 18.5424L11.726 16.2095L16.7841 19.9137C17.7118 20.4307 18.3654 20.1585 18.6156 19.0603L21.9358 3.50263L21.9367 3.50171C22.231 2.13038 21.4408 1.59413 20.537 1.93055L1.02115 9.4023C-0.31077 9.9193 -0.290603 10.6618 0.79473 10.9982L5.78415 12.5501L17.3736 5.29838C17.919 4.93721 18.4149 5.13705 18.007 5.49821L8.63223 13.916Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d7eaa80c62d3e1e5b13c98b2f75c959e.svg";
export { ForwardRef as ReactComponent };